// В.2.a: Лив Лайф — двухфазный проход хил-Аур в Ф3 (диздок 6.4).
//
// «Пассивные способности лечения союзных юнитов Лив Лайф срабатывают дважды
// за фазу: один раз ДО авто-атак, один раз ПОСЛЕ авто-атак».
//
// Архитектура:
//   - Каждая хил-Аура регистрирует себя через registerLivLifeHealAura(cardId, fn).
//   - В Ф3 phases.js дважды зовёт runLivLifeHealAuras(state, round) — раунд 1
//     ДО zigzag-атак, раунд 2 ПОСЛЕ. fn получает (state, card, round).
//   - Если ни одна Аура не зарегистрирована или на поле нет юнитов Лив Лайф —
//     оба прохода no-op без побочных эффектов на состояние.
//   - Молчание блокирует хил-Ауру: проверяем card.current?.silenced ИЛИ
//     card.silenceSources?.size > 0.
//   - Ауры регистрируются Героем-юнитом (id), а не каждым инстансом — fn
//     получает конкретный инстанс на поле.
//
// В каркасе В.2.a реальных Аур нет. Карты Лив Лайф будут регистрировать себя
// в шагах В.2.b и далее (например, Главврач Ариана — её пассивная Аура
// «восстанавливает 2 ХП самому раненому союзнику»).

const _auras = new Map(); // cardId -> fn(state, card, round)

// Зарегистрировать хил-Ауру: каждое срабатывание Ф3 будет звать fn для каждого
// живого юнита Лив Лайф на поле, у которого на template-id зарегистрирована Аура.
export function registerLivLifeHealAura(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  _auras.set(cardId, fn);
}

// Только для тестов: очистить все зарегистрированные ауры.
export function _resetLivLifeHealAurasForTests() {
  _auras.clear();
}

// Только для тестов: посмотреть, зарегистрирована ли Аура для cardId.
export function _hasLivLifeHealAuraForTests(cardId) {
  return _auras.has(cardId);
}

// Запустить раунд хил-Аур (round ∈ {1, 2}).
// Обходит все живые карты Лив Лайф на поле обеих сторон — ЮНИТЫ и ГЕРОИ
// (В.2.g: Ариана — Герой с хил-Аурой). Карты с Молчанием пропускаются.
export function runLivLifeHealAuras(state, round) {
  if (!state || !state.players) return;
  if (_auras.size === 0) return;
  for (const p of state.players) {
    if (!p) continue;
    const candidates = [];
    if (p.hero && p.hero.faction === 'livlife' && p.hero.hp > 0) {
      candidates.push(p.hero);
    }
    if (p.unitsOnField) {
      for (const u of p.unitsOnField()) {
        if (u && u.faction === 'livlife') candidates.push(u);
      }
    }
    for (const c of candidates) {
      if (c.type === 'unit' && (!c.isAlive || !c.isAlive())) continue;
      if (c.type === 'hero' && (c.hp == null || c.hp <= 0)) continue;
      // Молчание блокирует пассивные способности (и Ауры в т.ч.).
      if (c.current?.silenced) continue;
      if (c.silenceSources && c.silenceSources.size > 0) continue;
      const fn = _auras.get(c.id);
      if (!fn) continue;
      try {
        fn(state, c, round);
      } catch (e) {
        // Defensive: одна сломанная Аура не должна валить Ф3.
        console.warn(`[Корпы] хил-Аура ${c.id} упала:`, e);
      }
    }
  }
}
